import React, { Component } from "react";
import Carousel from './carousel.jsx';
class SerVueIngredientSlider extends Component {
    constructor(props) {
        super(props);
    }

    render() {


        if (this.props.imagesText) {
            const images = this.props.imagesText.split(',');
            const ingredients = this.props.ingredientsText.split(',');

            return (
                <Carousel options={{
                    prevNextButtons: false,
                    pageDots: false,
                    autoPlay: this.props.autoScroll === 'True' ? true : false,
                    groupCells: true,
                    cellAlign: 'left',
                    wrapAround: true,
                    lazyLoad: 2,
                }}>
                    {
                        images.map((image, index) => (
                            <div className="ser-vue-ingredient">
                                <img style={{ height: "100%", borderRadius: "0px" }} src={image} alt="" />
                                {
                                    this.props.showTitle === 'True' && ingredients.length >= (index + 1) && <span className="ser-vue-ingredient-title">{ ingredients[index] }</span>
                                }
                                    
                            </div>
                        ))
                    }
                </Carousel>
            );
        }

        return null;
    }
}

export default SerVueIngredientSlider;